import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const submitFinance = createAsyncThunk(
  'finance/submitFinance',
  async (data, thunkAPI) => {
    try {
      let endpoint = '';

      switch (data.type) {
        case 'income':
          endpoint = '/api/sales/create';
          break;
        case 'expense':
          endpoint = '/api/invoices/create';
          break;
        case 'expenses':
          endpoint = '/api/expenses/create';
          break;
        default:
          throw new Error('Ismeretlen finance típus');
      }

      const { data: res } = await axios.post(endpoint, data);
      return res;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const fetchMonthlyFinance = createAsyncThunk(
  'finance/fetchMonthlyFinance',
  async ({ year, month }, thunkAPI) => {
    try {
      const { data } = await axios.get(`/api/report/${year}/${month}`);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const financeSlice = createSlice({
  name: 'finance',
  initialState: {
    loading: false,
    error: null,
    success: false,
    transactions: [],
    summary: null,
  },
  reducers: {
    resetStatus: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitFinance.pending, (state) => {
        state.loading = true;
      })
      .addCase(submitFinance.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.transactions.push(action.payload);
      })
      .addCase(submitFinance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchMonthlyFinance.fulfilled, (state, action) => {
        state.loading = false;
        state.summary = action.payload;
      });
  },
});

export const { resetStatus } = financeSlice.actions;
export default financeSlice.reducer;
